'use client';

import { useEffect } from 'react';
import { regionAttributeNumberKeys } from '~/const/region';
import { Company, CompanyData } from '~/definitions/company';
import { Region, RegionData } from '~/definitions/region';
import { getStore } from '~/mobx/AppStore';
import { getAttributeValueByNumber } from '~/utils/getAttributeValueByNumber';

type Props = {
    region?: RegionData;
    company?: CompanyData;
};

const Client = (props: Readonly<Props>) => {
    const { company, region } = props;
    const { ballotStore } = getStore();

    const setCompanyData = () => {
        if (company) {
            const mappedCompany: Company = {
                companyName: company.name,
                companyId: company.id,
            };
            ballotStore.setSelectedSlagId(company.number);
            ballotStore.setCompany(mappedCompany);
        }
    };

    const setRegionData = () => {
        if (region) {
            const mappedRegion: Region = {
                regionName: region.name,
                regionExtraVoteLabel: getAttributeValueByNumber(
                    regionAttributeNumberKeys.regionExtraVoteLabel,
                    region.attributes || []
                ),
                regionDescription: getAttributeValueByNumber(
                    regionAttributeNumberKeys.regionDescription,
                    region.attributes || []
                ),
                regionExtraVoteQuantity: getAttributeValueByNumber(
                    regionAttributeNumberKeys.regionExtraVoteQuantity,
                    region.attributes || []
                ),
                regionNoVoteDescription: getAttributeValueByNumber(
                    regionAttributeNumberKeys.regionNoVoteDescription,
                    region.attributes || []
                ),
            };

            ballotStore.setSelectedRegionId(region.id);
            ballotStore.setRegion(mappedRegion);
        }
    };

    useEffect(() => {
        if (company) {
            setCompanyData();
        }

        if (region) {
            setRegionData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [company, region]);

    return null;
};

export default Client;
